import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

import { Modal } from 'ggApp/modules/modal/components/v3';

const COOKIE_MODAL_CLASS_NAME = 'cookieModalContainer';
const COOKIE_MODAL_CONTENT_CLASS_NAME = 'cookieModalContent';
const COOKIE_MODAL_ACTIONS_CONTAINER_CLASS_NAME = 'cookieModalActionsContainer';

export const StyledModal = styled(Modal).attrs({
    classNames: {
        container: COOKIE_MODAL_CLASS_NAME,
        content: COOKIE_MODAL_CONTENT_CLASS_NAME,
        actionsContainer: COOKIE_MODAL_ACTIONS_CONTAINER_CLASS_NAME,
    },
})`
    & .${COOKIE_MODAL_CONTENT_CLASS_NAME} {
        padding: 24px;
    }
    & .${COOKIE_MODAL_ACTIONS_CONTAINER_CLASS_NAME} {
        background-color: ${({ theme }) => theme.colors.Background};
        border-top: 2px solid ${({ theme }) => theme.colors['Level 1']};
        justify-content: flex-start;
        padding: 24px;
        ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
            flex-direction: column;
            align-items: center;
            height: unset;
            padding: 16px;
        `}
    }
`;

export const ModalHeader = styled.div`
    ${({ theme }) => theme.typography.Headline};
`;

export const ModalHeaderText = styled.div`
    ${({ theme }) => theme.typography.Paragraph};
    margin-top: 8px;
    a {
        color: ${({ theme }) => theme.colors.secondary};
        text-decoration: underline;
    }
`;

export const AcceptButton = styled(ButtonV2)`
    margin: 16px 0;
    min-width: 128px;
`;

export const SaveButton = styled(ButtonV2)`
    margin: 32px 0px 16px;
    min-width: 128px;
`;

export const CloseWrapper = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    width: 32px;
    top: 16px;
    right: 16px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    cursor: pointer;
`;
